// extracted by mini-css-extract-plugin
export var closeButton = "_2y-0";